import { LicenseModel } from "gc-web-proto/galaxycompletepb/apipb/domainpb/enumpb/license_model_pb";
import { ProjectDetails, ProjectInfo } from "gc-web-proto/galaxycompletepb/apipb/domainpb/project_pb";

export const DEMO_DASHBOARD_PROJECT_ID = "__presentation_dashboard_demo__";
export const isDemoDashboardProject = (projectId: string | null | undefined) => projectId === DEMO_DASHBOARD_PROJECT_ID;

export const demoProject = new ProjectDetails().setInfo(
    new ProjectInfo()
        .setProjectId(DEMO_DASHBOARD_PROJECT_ID)
        .setName("Meridian Global Modernization (Demo)")
        .setDescription("Illustrative data for 100,000 VMware VMs moving from on-premises sites to AWS and Azure")
        .setLicenseModel(LicenseModel.LicenseModel.HOST_BASED)
        .setProjectFlagsList(["datasync", "disaster-recovery"])
);
